import { render, staticRenderFns } from "./defaultUsageConfigDialog.vue?vue&type=template&id=63805e25&scoped=true"
import script from "./defaultUsageConfigDialog.vue?vue&type=script&lang=js"
export * from "./defaultUsageConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./defaultUsageConfigDialog.vue?vue&type=style&index=0&id=63805e25&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63805e25",
  null
  
)

export default component.exports